<script lang="ts">
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { page } from '$app/state';
	import { HeniNewsLogo } from '$global/assets/logos/HeniNewsLogo';
	import { IconLink } from '$global/components/IconLink';
	import { getNavBarContext } from '$global/features/navigation/utils/getNavBarContext/getNavBarContext';

	const { popover } = getNavBarContext();
</script>

<IconLink
	dataCy="header"
	href={page.url.searchParams.get('global_nav') === '0'
		? `${GlobalRoutes.NewsHome}?global_nav=0`
		: GlobalRoutes.NewsHome}
	label="See HENI News home page"
	class="outline-none"
	onclick={() => {
		popover?.states?.open?.set(false);
	}}
>
	<HeniNewsLogo color="gray-900" class="xs:scale-100 origin-left scale-75" />
</IconLink>
